var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeBanner"},[_c('el-carousel',{attrs:{"indicator-position":"none","height":"88vh","arrow":"hover"}},_vm._l((_vm.list),function(item){return _c('el-carousel-item',{key:item},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.staticUrl+item.image,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }